import { useLayoutEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const TARGET_ID = 'app-shell-topbar-actions';

export function TopBarAction({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setTarget(document.getElementById(TARGET_ID));
  }, []);

  if (!target) return null;
  return createPortal(children, target);
}
